export module AppSettings {
    export class Paths {

      
        static BaseAssetsPath: string = "assets/";
        static BaseModelsPath: string = "static/models/";
        static BaseMaterialsPath: string = "static/materials/";

        static MoveIcon: string =  "images/icons/move.png"
        static LinkIcon: string = "images/icons/link.png"
        static InsertIcon: string ="images/icons/insert.png"
        static DeleteIcon: string =  "images/icons/delete.png"
        static RotateIcon: string = "images/icons/rotate.png"
    }            
    
}   
